export default __webpack_public_path__ + "static/media/intro-img-3928.77c8d9c2.png";